/* Mirrors the selected variant's price into the PDP Add to cart button.

   Dawn re-renders the section server-side on every variant change and
   product-info.js publishes PUB_SUB_EVENTS.variantChange with that html, so
   the price is copied from the freshly rendered document exactly the way
   Dawn mirrors its own Price/Sku/Inventory nodes. Money is never formatted
   in JavaScript and never computed from variant.price: Liquid's | money
   already ran server-side for the new variant inside that html, which is
   what keeps Markets and multi-currency correct — same rule as the offer
   widget in the build plan.

   An absent source node means the new variant renders no price (sold out),
   so the live one empties; the label span is product-form.js's own and is
   never touched here. The target-node guard keeps featured-product, which
   does not pass show_price, unaffected. */

subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  const { sectionId, html } = event.data;
  const target = document.getElementById(`ProductSubmitPrice-${sectionId}`);
  if (!target) return;
  const source = html.getElementById(`ProductSubmitPrice-${sectionId}`);
  target.innerHTML = source ? source.innerHTML : '';
});
